export default "__VITE_ASSET__NJTxXAXC__"